.modal {
  width: 100vw;
  height: 100vh;
  z-index: 12;
  position: fixed;
}
